$(function () {
  var $body = $('body');

  // only works on course listing page
  if (!$body.hasClass('page-type--coursearea')) return;

  var api = '/umbraco/api/searchapi/filtercourses/';
  var courseListing, courseFilters;

  // list instance
  courseListing = new Vue({
    el: '.courses-listing',
    data: courses, // from the initial load data
    methods: {

      prev: function () {
        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedMode.value,
            Math.max(1, this.pageNumber - 1));
      },

      next: function () {
        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedMode.value,
            Math.min(this.pageNumber + 1, this.totalPages));
      },

      reset: function () {
        courseFilters.fetchOnUpdate = false; // disable fetch-on-update for a moment
        courseFilters.selectedCampus = courseFilters.campuses[0];
        courseFilters.selectedMode = courseFilters.modes[0];
        courseFilters.fetchOnUpdate = true;

        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedMode.value, 1);
      },

      ga: function () {
        gtag && gtag('event', 'Select a course', {
          event_category: 'Course Landing',
          transport_type: 'beacon'
        });
      },

      fetch: function (campus, mode, page) {
        var vm = this;
        $.getJSON(api, {
          umbracopageId: currentPage, // from initial load
          page: page || 1,
          campus: campus,
          studymode: mode
        }, function (data) {
          vm.pageSize = data.pageSize;
          vm.pageNumber = data.pageNumber;
          vm.totalItems = data.totalItems;
          vm.totalPages = data.totalPages;
          vm.items = data.items;
        })
      },

      freeModal: function (event) {
        event.preventDefault();
        openFeeFreeModal();
      }
    }
  });

  // filter instance
  courseFilters = new Vue({
    el: '.filters--courses-listing',
    data: function () {
      var data = {
        campuses: LOCATIONS,
        modes: STUDY_MODES,
        fetchOnUpdate: true
      };

      data.selectedCampus = data.campuses[0];
      data.selectedMode = data.modes[0];
      return data;
    },
    created: function () {

    },
    computed: {
      selectedCampusLabel: function () {
        if (this.selectedCampus === null)
          return 'Any Campus';

        return this.selectedCampus.label;
      },
      selectedModeLabel: function () {
        if (this.selectedMode === null)
          return 'Any Mode';

        return this.selectedMode;
      },
    },
    watch: {
      selectedCampus: function (newCampus) {
        if (this.fetchOnUpdate)
          courseListing.fetch(newCampus.value, this.selectedMode.value)
      },
      selectedMode: function (newMode) {
        if (this.fetchOnUpdate)
          courseListing.fetch(this.selectedCampus.value, newMode.value)
      }
    },
    methods: {
      selectCampus: function (evt, campus) {
        this.toggleDropdown(evt, false);
        this.selectedCampus = campus;
      },

      isCampusSelected: function (campus) {
        return this.selectedCampus === campus;
      },

      isModeSelected: function (mode) {
        return this.selectedMode === mode;
      },

      selectMode: function (evt, mode) {
        this.toggleDropdown(evt, false);
        this.selectedMode = mode;
      },

      toggleDropdown: function (evt, flag) {
        var $filter = $(evt.target).parents('.filter');
        $filter.toggleClass('open', flag);
      },
    }
  });
});